import PublishThirdPartyCollectionModal from './PublishThirdPartyCollectionModal.container'

export default PublishThirdPartyCollectionModal
